import {
    IAnalyticsModelIndicatorChild,
    IAnalyticsModelResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { MemoizedTable } from 'components/data_table/Table';
import { TableColumn } from 'components/data_table/types';
import { NoValue } from 'components/no_value/NoValue';

export type AnalyticsModelIndicatorsTableProps = Readonly<{
    analyticsModel: IAnalyticsModelResponse;
}>;

export function AnalyticsModelIndicatorsTable({
    analyticsModel,
}: AnalyticsModelIndicatorsTableProps) {
    const columns: TableColumn<IAnalyticsModelIndicatorChild>[] = [
        {
            id: 'Name',
            header: () => 'Name',
            value: ({ rowData }) => rowData.IndicatorName,
            primary: true,
        },
        {
            id: 'Type',
            header: () => 'Type',
            value: ({ rowData }) => rowData.IndicatorType,
        },
        {
            id: 'Units',
            header: () => 'Units',
            value: ({ rowData }) => rowData.IndicatorUnits ?? <NoValue />,
        },
    ];

    return (
        <div className="p-20">
            {analyticsModel.Indicators.length === 0 ? (
                <span>No indicators</span>
            ) : (
                <MemoizedTable
                    lockHeaders
                    maxHeight="50rem"
                    data={analyticsModel.Indicators}
                    rowKey={(indicator) => indicator.IndicatorName}
                    showPageSizeDropdown={false}
                    columns={columns}
                />
            )}
        </div>
    );
}
